import React from 'react';
import baseComponent from '../../decorators/baseComponent';
import styles from './CountryDropDown.scss';
import BaseReactComponent from './BaseReactComponent';
import CountryList from './CountryList';
import { DropDownMenu, MenuItem } from 'material-ui';

@baseComponent(styles) class CountryDropDown extends BaseReactComponent {

    constructor() {
        super();
        this.state = {};
        this.state.choices = CountryList;
    }

    pickedCountry(event, countryI) {
        this.props.onChange('country', CountryList[countryI].id);
        this.state.country = countryI;
    }

    render() {
        if (this.props.edit) {
            //let placeholder = 'Select country';
            //if (this.props.placeholder) {
            //  placeholder = this.props.placeholder;
            //}
            if (this.props.country) {
                let initial = this.state.choices.filter(c => {
                    if (c.id === this.props.country) {
                        return true;
                    }
                });

                if (initial !== undefined) {
                    this.state.country = CountryList.indexOf(initial[0]);
                }
            } else {
                this.state.country = undefined;
            }

            let self = this;
            let menuItems = this.state.choices.map(function (country, index) {
                return <MenuItem key={index} value={index} primaryText={self.getIntlMessage('country.' + country.id)} />;
            });

            if (!this.props.includeAllCountries) {
                menuItems.splice(menuItems.length - 1, 1);
            }

            let css = {
                borderTop: "solid 1px #e0e0e0",
                bottom: "1px",
                left: "0",
                margin: "0",
                right: "0",
                position: "absolute"
            };

            let labelcss = {
                lineHeight: 40 + 'px'
            };

            return (
                //<DropDown initialValue={initial}
                //          placeholder={placeholder}
                //          searchPlaceholder="Search country"
                //          customClass="Country-dropdown"
                //          optionValueKey="id"
                //          optionLabelKey="display"
                //          searchable={true}
                //          onChange={}
                //          dataSource={this.state.choices}/>
                <DropDownMenu className="countryDropDown" onChange={this.pickedCountry.bind(this)} autoWidth={true} value={this.state.country !== undefined ? this.state.country : 99} underlineStyle={css} labelStyle={labelcss}>
                    {menuItems}
                    <MenuItem disabled key={99} value={99} primaryText={this.getIntlMessage('homepage.installer-company-editor.pick')} />
                </DropDownMenu>
            );
        } else {
            return (
                <span className="Country">{this.props.country}</span>
            );
        }
    }
}

CountryDropDown.propTypes = {
    country: React.PropTypes.string
};
export default CountryDropDown;



// WEBPACK FOOTER //
// /src/components/Util/CountryDropDown.js